<template>
  <div class="auth-layout grid grid-cols-12 content-center">
    <div class="flex col-span-12 p-1 justify-center">
      <router-link class="justify-center flex" to="/"> <Logo blacked class="w-56 h-24" /> </router-link>
    </div>

    <div class="flex justify-center col-span-12 p-4">
      <va-card class="auth-layout__card">
        <va-card-content>
          <!-- <va-tabs v-model="tabIndex" center>
            <template #tabs>
              <va-tab name="login">{{ t('auth.login') }}</va-tab>
            </template>
          </va-tabs>

          <va-separator /> -->

          <div class="p-3 flex justify-center">
            <router-view />
          </div>
        </va-card-content>
      </va-card>
    </div>
  </div>
</template>

<script>
  import { useI18n } from 'vue-i18n'
  import Logo from '@/components/Logo.vue'
  export default {
    name: 'AuthLayout',
    components: { Logo },
    setup() {
      const { t } = useI18n()
      return { t }
    },
    data() {
      return {
        selectedTabIndex: 0,
      }
    },
    computed: {
      tabIndex: {
        set(tabName) {
          this.$router.push({ name: tabName })
        },
        get() {
          return this.$route.name
        },
      },
    },
  }
</script>

<style lang="scss">
  .auth-layout {
    min-height: 100vh;
    background-image: linear-gradient(to right, var(--va-background-primary), var(--va-white));

    &__card {
      width: 100%;
      max-width: 600px;
    }
  }
</style>
